// extracted by mini-css-extract-plugin
export default {"wrapper":"TOhmDn9KvRHD359hMdPy","quotaAttainment":"GUbuNR48FsELuoJ8Vd8f"};